import React, { useState } from 'react';
import type { SupplierCategory } from '../../types/supplier';
import FilterContainer from '../filters/FilterContainer';
import FilterSection from '../filters/FilterSection';
import CategorySelect from '../filters/CategorySelect';

interface SupplierFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  categories: SupplierCategory[];
  selectedCategories: SupplierCategory[];
  onCategoryToggle: (category: SupplierCategory) => void;
}

const SupplierFilters: React.FC<SupplierFiltersProps> = ({
  search,
  onSearchChange,
  categories,
  selectedCategories,
  onCategoryToggle
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="card p-6 mb-8">
      <div className="space-y-6">
        {/* Search and Toggle */}
        <div className="flex items-center gap-4">
          {/* Search Input */}
          <div className="flex-grow relative">
            <input
              type="text"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search suppliers..."
              className="w-full px-4 py-2.5 bg-background border border-gray-800 rounded-lg text-content-primary placeholder-content-secondary focus:ring-2 focus:ring-brand focus:border-brand transition-colors"
            />
          </div>

          {/* Toggle Button */}
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="flex items-center gap-2 px-4 py-2.5 bg-background border border-gray-800 rounded-lg text-content-primary hover:bg-background-secondary transition-colors"
          >
            <span>{isExpanded ? 'Hide Filters' : 'Show Filters'}</span>
          </button>
        </div>

        {/* Filter Content */}
        {isExpanded && (
          <div className="pt-6 border-t border-gray-800">
            <FilterSection title="Categories">
              <CategorySelect
                categories={categories}
                selectedCategories={selectedCategories}
                onToggle={onCategoryToggle}
              />
            </FilterSection>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupplierFilters;